import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = () => {
  const { accessToken, isLoggedOut } = useAuth();
  if (!accessToken && isLoggedOut) {
    return <Navigate to="/dashboard/login" replace />;
  }
  return <Outlet />;
};
export default ProtectedRoute;
